import { call } from 'redux-saga/effects';

export default function* postMessageToBackground({ type, payload = {} }) {
  yield call(
    window.postMessage,
    {
      type,
      payload,
      meta: { source: 'febes' },
    },
    window.location.origin
  );
}
